import { render, staticRenderFns } from "./ImagesCarousel.vue?vue&type=template&id=1b3eaa30&scoped=true"
import script from "./ImagesCarousel.vue?vue&type=script&lang=js"
export * from "./ImagesCarousel.vue?vue&type=script&lang=js"
import style0 from "./ImagesCarousel.vue?vue&type=style&index=0&id=1b3eaa30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3eaa30",
  null
  
)

export default component.exports